import { render, staticRenderFns } from "./Zones.vue?vue&type=template&id=08bcce15&"
import script from "./Zones.vue?vue&type=script&lang=ts&"
export * from "./Zones.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports